import {AppStatus} from "./App";
import classes from "./ResultArea.module.css";
import React, {useEffect, useState} from "react";

type Props = {
    setAppStatus: (appStatus: AppStatus) => void
}

export const ResultArea = ({setAppStatus}: Props) => {

    const [time, setTime] = useState<string>("")
    const [tryCount, setTryCount] = useState<string>("")

    useEffect(()=>{
        setTime(document.getElementById("time")!.innerText)
        setTryCount(document.getElementById("try")!.innerText)

    },[])

    const twitText = () => {
        const text = `真の黒をあなたは見つけられるか！？%0A%0A私のスコア%0Aタイム：${time}%0A挑戦回数：${tryCount}%0A`
        const tag = "black300,アンミカ,ダウンタウンDX"
        const url = "https://black-300.com%0A%0A";

        if (text.length > 140) {
            //文字数制限
            alert("テキストが140字を超えています");
        } else {
            //投稿画面を開く
            const apiUrl = `http://twitter.com/intent/tweet?url=${url}&hashtags=${tag}&text=${text}`
            return apiUrl
        }
    }

    return (
        <>
            <div className={classes.resultArea}>
                <div className={classes.content}>
                    <div className={classes.infoText}>真の黒を見つけた！<br/>おめでとう！👏</div>

                    <div className={classes.resultText}>
                        <div className={classes.time}>タイム: {time}</div>
                        <div className={classes.try}>挑戦回数: {tryCount}</div>
                        <a className={classes.resultTwitterShareIcon}  href={twitText()} target="_blank" rel="noreferrer" >結果をシェアする</a>
                    </div>

                    <button className={classes.restartButton} onClick={() => setAppStatus("ready")}>再挑戦！</button>
                </div>
            </div>
        </>
    )
}